(function () {
  'use strict';

  var config = window.SFP_CONFIG;
  if (!config || !config.shades || !config.shades.length) return;

  var root = document.getElementById('shade-finder-popup');
  if (!root) return;

  var shadeClicks = 0;
  var lastCountedShadeName = '';
  var lastFocus = null;
  var hueCloseTimer = null;

  var dialog = root.querySelector('.sfp__dialog');
  var nameEl = root.querySelector('[data-sfp-name]');
  var descEl = root.querySelector('[data-sfp-desc]');
  var swatchEl = root.querySelector('[data-sfp-swatch]');

  function swatchStyle(swatch) {
    if (!swatch) return '';
    if (swatch.indexOf('url(') === 0) {
      return 'background-image:' + swatch + ';background-size:cover;background-position:center';
    }
    return 'background-color:' + swatch;
  }

  function normalizeShadeName(name) {
    return name ? String(name).toLowerCase().trim() : '';
  }

  function findShadeByName(name) {
    if (!name) return null;
    var needle = normalizeShadeName(name);
    for (var i = 0; i < config.shades.length; i++) {
      if (String(config.shades[i].name).toLowerCase().trim() === needle) return config.shades[i];
    }
    return null;
  }

  function currentShadeFromDom() {
    var radio = document.querySelector('product-info .product-form__input--pill input[type="radio"]:checked');
    var swatchLabel = null;
    if (radio && radio.id) {
      swatchLabel = document.querySelector(
        'label[for="' + radio.id + '"][js-shade-swatch], label[for="' + radio.id + '"][js-dropdown-item]'
      );
    }
    var name = swatchLabel && (swatchLabel.getAttribute('data-value') || swatchLabel.getAttribute('data-title'));
    return findShadeByName(name) || config.shades.filter(function (s) { return s.selected; })[0] || config.shades[0];
  }

  function renderShade(shade) {
    if (!shade) return;
    if (nameEl) nameEl.textContent = shade.name || '';
    if (descEl) descEl.textContent = shade.description || '';
    if (swatchEl) swatchEl.setAttribute('style', swatchStyle(shade.swatch));
  }

  function closeHueQuiz() {
    var loader = document.getElementById('hue-widget-loader');
    if (loader) loader.remove();
    var closeBtn = document.querySelector(
      '.hue-header .hue-icon-button[aria-label="Close Quiz"], .hue-quiz-modal [aria-label="Close Quiz"], .hue-app-quiz-modal [aria-label="Close Quiz"], [class*="hue-quiz-modal"] button[aria-label="Close"], [class*="hue-quiz-modal"] [aria-label="Close"]'
    );
    if (closeBtn) closeBtn.click();
  }

  function isHueBlocked() {
    return !!window.__sfpBlockHueQuiz;
  }

  function hideHueOnShadeClick() {
    window.__sfpBlockHueQuiz = true;
    document.documentElement.classList.add('sfp-hide-hue');
    closeHueQuiz();
    if (hueCloseTimer) clearInterval(hueCloseTimer);
    var attempts = 0;
    hueCloseTimer = setInterval(function () {
      attempts++;
      if (!isHueBlocked() || attempts > 30) {
        clearInterval(hueCloseTimer);
        hueCloseTimer = null;
        return;
      }
      closeHueQuiz();
    }, 150);
  }

  function allowHueModal() {
    window.__sfpBlockHueQuiz = false;
    document.documentElement.classList.remove('sfp-hide-hue');
    if (hueCloseTimer) {
      clearInterval(hueCloseTimer);
      hueCloseTimer = null;
    }
  }

  function isOpen() {
    return !root.hasAttribute('hidden');
  }

  function openPopup(shade) {
    renderShade(shade || currentShadeFromDom());
    lastFocus = document.activeElement;
    root.hidden = false;
    root.removeAttribute('hidden');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sfp-open');
    if (dialog) dialog.focus();
  }

  function closePopup() {
    root.hidden = true;
    root.setAttribute('hidden', '');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sfp-open');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  var selectedOnLoad = currentShadeFromDom();
  lastCountedShadeName = selectedOnLoad ? normalizeShadeName(selectedOnLoad.name) : '';

  document.addEventListener(
    'click',
    function (e) {
      var inHue = e.target.closest('.hue-quiz-modal, .hue-app-quiz-modal, [class*="hue-quiz-modal"]');
      if (inHue) return;

      var findShade = e.target.closest('[data-sfp-find-shade]');
      var noButton = e.target.closest('[data-sfp-no-button]');
      if (noButton) {
        closePopup();
        return;
      }
      if (findShade) {
        if (typeof window.__sfpAllowHueQuiz === 'function') window.__sfpAllowHueQuiz();
        else allowHueModal();
        closePopup();
        return;
      }

      var hueTrigger = e.target.closest('[data-hue-trigger="quiz"], [data-hue-trigger-paused]');
      if (hueTrigger && e.isTrusted) {
        if (typeof window.__sfpAllowHueQuiz === 'function') window.__sfpAllowHueQuiz();
        else allowHueModal();
        return;
      }
      if (hueTrigger && !e.isTrusted && isHueBlocked()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      var closeEl = e.target.closest('[data-sfp-close]');
      if (closeEl && root.contains(closeEl)) {
        closePopup();
        return;
      }

      var shadeEl = e.target.closest('[js-shade-swatch], [js-dropdown-item], .js-dropdown-item, .swatch_img_new');
      if (!shadeEl || !e.isTrusted) return;
      if (shadeEl.closest('#shade-finder-popup')) return;
      if (!shadeEl.closest('product-info, product-info-bundle, product-info-sticky, variant-selects, [js-product-info-wrapper]')) return;

      hideHueOnShadeClick();
      if (typeof window.__sfpBlockHueQuizNow === 'function') window.__sfpBlockHueQuizNow();

      var label = shadeEl.closest('[js-shade-swatch], [js-dropdown-item]') || shadeEl;
      var shadeName = label.getAttribute('data-value') || label.getAttribute('data-title');
      var normalized = normalizeShadeName(shadeName);
      if (!normalized || normalized === lastCountedShadeName) return;

      lastCountedShadeName = normalized;

      var shade = findShadeByName(shadeName) || currentShadeFromDom();

      shadeClicks += 1;
      if (shadeClicks !== 2 || isOpen()) return;

      setTimeout(function () {
        openPopup(shade);
      }, 250);
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) {
      closePopup();
    }
  });

  document.addEventListener('hue-integration', function (e) {
    if (!isHueBlocked()) return;
    if (e.detail && e.detail.type === 'quiz-modal-ready') closeHueQuiz();
  });

  window.ShadeFinderPopup = {
    open: openPopup,
    close: closePopup
  };
})();

